package pl.decks.chartjs.radar.options

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption
import pl.decks.chartjs.model.JSScriptableIndexable

data class PointLabelOptions(
    val display: Boolean = true,
    val color: JSScriptableIndexable<ChartColor>? = null,
    val padding: Int? = null,
    val centerPointLabels: Boolean? = null,
    val font: FontOptions? = null,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        this.display = display.asDynamic()
        if (color != null) this.color = color.toChartJs { it.toChartJs() }
        if (padding != null) this.padding = padding.asDynamic()
        if (centerPointLabels != null) this.centerPointLabels = centerPointLabels.asDynamic()
        if (font != null) this.font = font.toChartJs()
    }
}
